import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  async copy(event) {
    event?.preventDefault()
    event?.stopPropagation()
    await navigator.clipboard.writeText(this.sourceTarget.textContent.trim())
    const original = this.buttonTarget.innerHTML
    this.buttonTarget.innerHTML = '<i class="fa-solid fa-check me-1"></i>Copied!'
    setTimeout(() => { this.buttonTarget.innerHTML = original }, 2000)
  }
}
